<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm='2' class='padding0'>
        <b-form-select class="float-left location-filter-select" v-model="locationFilter" :options="locationFilterOptions"></b-form-select>
      </b-col>
      <b-col sm='10'>
        <div>
          <div class='flexRowEnd flexRowWrap marginB-32'>
            <download-csv
              v-if="tabIndex === 1"
              :data="screeningsByOrg"
              name="screenings.csv"
            >
              <b-btn class="bgDarkBlue marginR-5" variant="primary">Download Screenings by Concern Level <arrow-down width='16' height='16' color='white' /></b-btn>
            </download-csv>

            <download-csv
              v-if="tabIndex === 3"
              :data="laborScreeningsByOrg"
              name="screenings.csv"
            >
              <b-btn class="bgDarkBlue marginR-5" variant="primary">Download Screenings by Conclusion <arrow-down width='16' height='16' color='white' /></b-btn>
            </download-csv>

            <b-button-toolbar style="margin: 0px 5px 15px 0px;">
              <download-csv
                style="display:inline"
                :data=allUsers
                name="users.csv">
                <b-btn class="bgDarkBlue float-right marginR-5" variant="primary">Download Users <arrow-down width='16' height='16' color='white' /></b-btn>
              </download-csv>
              <download-csv
                  :data=allOrgs
                  name="organizations.csv">
                  <b-btn class="bgDarkBlue float-right marginR-5" variant="primary" >Download Orgs <arrow-down width='16' height='16' color='white' /></b-btn>
                </download-csv>
              <download-csv
                  style="display:inline"
                  :data=allGroups
                  name="groups.csv">
                  <b-btn class="bgDarkBlue float-right marginR-5" variant="primary" >Download Groups <arrow-down width='16' height='16' color='white' /></b-btn>
                </download-csv>
              <download-csv
                style="display:inline"
                :data=allLogs
                name="logs.csv">
                <b-btn class="bgDarkBlue float-right" variant="primary">Download Logs <arrow-down width='16' height='16' color='white' /></b-btn>
              </download-csv>
            </b-button-toolbar>

            <b-btn v-b-toggle.collapse1 variant="primary" class='filterBtn bgDarkBlue marginB0'>Time<img :src="require('../../../static/img/filterIcon.png')" width='17px' height='11px' style='margin-left: 14px' /></b-btn>
          </div>

          <b-collapse id="collapse1" class="filterCollapse flexRowEnd">
            <b-card>
              <div class='div1'>
                <span>Time</span>
                <!-- function name? -->
                <!-- <b-btn v-on:click.prevent="resetFilters">Clear Filters</b-btn> -->
              </div>
              <div class='div2'>
                  <b-form-radio-group id="radiosBtn" buttons button-variant="secondary" v-model="statisticsTimeInterval" name="radiosBtn">
                    <b-form-radio class="mx-0 firstBtn" value="Day" >Last 30 Days</b-form-radio>
                    <b-form-radio class="mx-0" value="Month" >Month</b-form-radio>
                    <b-form-radio class="mx-0" value="Quarter">Quarter</b-form-radio>
                    <b-form-radio class="mx-0" value="Year">Year</b-form-radio>
                  </b-form-radio-group>

                  <date-range-picker
                    ref="picker"
                    opens="left"
                    :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                    :maxDate="new Date()"
                    singleDatePicker="range"
                    :timePicker="false"
                    :timePicker24Hour="false"
                    :showWeekNumbers="false"
                    :showDropdowns="true"
                    :autoApply="false"
                    v-model="customDateRange"
                    :ranges="false"
                    @select="handleSelect"
                  >
                    <template #header>
                      <div class="date-range-picker__header">
                        <b-form-group
                          label="Start Date:"
                          label-for="startDate"
                          label-size="sm"
                          class="mb-0"
                        >
                          <b-form-input
                            class="mb-0"
                            data-vv-name="startDate"
                            data-vv-as="startDate"
                            id="startDate"
                            size="sm"
                            type='text'
                            name="startDate"
                            v-model="customDateRange.startDate"
                          />
                        </b-form-group>
                        <b-form-group
                          label="End Date:"
                          label-for="endDate"
                          label-size="sm"
                          class="mb-0"
                        >
                          <b-form-input
                            class="mb-0"
                            data-vv-name="endDate"
                            data-vv-as="endDate"
                            id="endDate"
                            size="sm"
                            type='text'
                            name="endDate"
                            v-model="customDateRange.endDate"
                          />
                        </b-form-group>
                      </div>
                    </template>
                    <template v-slot:input>
                      <b-button :class="['mx-0', { 'active': statisticsTimeInterval === 'Custom' }]" variant="secondary">
                        Custom
                      </b-button>
                    </template>
                    <template v-slot:footer="picker">
                      <div class="date-range-picker__footer">
                        <b-button type="button" @click="saveCustomDateRange(picker.clickApply)" variant="primary">
                          Save
                        </b-button>
                      </div>
                    </template>
                  </date-range-picker>

                  <b-form-radio button class="mx-0 lastBtn" v-model="statisticsTimeInterval" button-variant="secondary" value="All" >All</b-form-radio>
              </div>
            </b-card>
          </b-collapse>
        </div>
      </b-col>
    </b-row>

    <b-tabs v-model="tabIndex" id="global-statistics-tabs" class='statisticsTabs'>
      <b-tab title="Overall Demographics">
        <b-row class='marginB-14'>
          <b-col sm="12" md="3" class='padding0 marginR-42'>
            <b-card class="text-white bg-info">
              <div class='flexRowBetween'>
                <h1> {{ rptgeneralCounts.personCount === null ? 0 : rptgeneralCounts.personCount }}</h1>
                <account-icon :size='45' />
                </div> 
              <h6 class='weight-300 marginB0'>All People</h6>
            </b-card>
          </b-col>

          <b-col sm="12" md="3" class='padding0 marginR-42'>
            <b-card class="text-white bg-danger clickable-card" @click="goToConfirmed">
              <div class='flexRowBetween flexRowAlignBaseline'>
                <div class='flexRowAlignBaseline'>
                  <h1>{{ rptgeneralCounts.confirmedPersonCount === null ? 0 : rptgeneralCounts.confirmedPersonCount }}</h1>
                  <h5>({{ percentConfirmedPersons }}%)</h5>
                </div>
                <img src="../../../static/img/asterisk-white.png" width='28.83' height='30' />
              </div>
              <h6 class='weight-300 marginB0'>Confirmed Victims</h6>
            </b-card>
          </b-col>

          <b-col sm="12" md="3" class='padding0'>
            <b-card class="clickable-card bg-secondary" @click="goToBlankConfirmed">
              <div class='flexRowBetween flexRowAlignBaseline'>
                <div class='flexRowAlignBaseline'>
                  <h1>{{ rptgeneralCounts.possiblePersonCount === null ? 0 : rptgeneralCounts.possiblePersonCount }}</h1>
                  <h5>({{ percentUnconfirmedPersons }}%)</h5>
                </div>
                <img src="../../../static/img/pie-black.png" width='30' height='30' />
              </div>
              <h6 class='weight-300 marginB0'>Others</h6>
            </b-card>
          </b-col>
        </b-row>
        <!-- Persons By Time -->
          <b-card class='marginB-62'>
            <h4 class="card-title marginB-32">People over Time</h4>
              <!--
              <b-button-toolbar class="float-left">
                <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="personsTimeInterval" name="radiosBtn">
                  <b-form-radio v-if="!hideDayGraphFilter" class="mx-0" value="Day" >Last 30 Days</b-form-radio>
                  <b-form-radio v-if="!hideMonthGraphFilter" class="mx-0" value="All" >Month</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
              -->
          <main-chart
            class="chart-wrapper"
            style="height:200px"
            height="200"
            chartName="People"
            :apiData="rptpersonCountsByTime"
            v-if="!rptpersonCountsByTimeError"
          >
          </main-chart>
          <p v-if="rptpersonCountsByTimeError">There is no data for this chart.</p>
        </b-card>

        <b-card class='marginB-62'>
          <h4 class="card-title marginB-32">Demographics by Status</h4>
              
            <b-form-group
              class='pillSelector'
              label-cols="4"
              label-text-align="center"

              label-size='lg'
              label-class='addpersonlabel'
              label='Group By'
              label-for='demographic'
              horizontal
            >
              <b-form-select
                size="lg"
                :options="biographicOptions"
                id='demographic'
                v-model='demographicField'
              >
              </b-form-select>
            </b-form-group>
            <p v-if="rptPersonCountsByDemographicError">There is no data for this chart.</p>
            <b-row v-if="!rptPersonCountsByDemographicError">
              <b-col md="4">
                <h4 class="text-center">All People</h4>
                <chart-legend-wrap 
                  type='pie' 
                  :apiData="rptPersonCountsByDemographic"
                  valueField="personCount"
                >
                  <pie-chart
                    height='300'

                    class="chart-wrapper"
                    chartName="Total People"
                    :apiData="rptPersonCountsByDemographic"
                    valueField="personCount"
                    :groupedBy="demographicField"
                  ></pie-chart>
                </chart-legend-wrap>
              </b-col>

              <b-col md="4">
                <h4 class="text-center">Confirmed Victims</h4>
                <chart-legend-wrap type='pie' :apiData="rptPersonCountsByDemographic" valueField="confirmedVictimCount">
                  <pie-chart
                  height='300'
                    class="chart-wrapper"
                    chartName="Confirmed Victims"
                    :apiData="rptPersonCountsByDemographic"
                    valueField="confirmedVictimCount"
                    :groupedBy="demographicField"
                  ></pie-chart>
                </chart-legend-wrap>
              </b-col>

              <b-col md="4">
                <h4 class="text-center">Others</h4>
                <chart-legend-wrap type='pie' :apiData="rptPersonCountsByDemographic" valueField="possibleVictimCount">
                  <pie-chart
                  height='300'
                    class="chart-wrapper"
                    chartName="Possible Victims"
                    :apiData="rptPersonCountsByDemographic"
                    valueField="possibleVictimCount"
                    :groupedBy="demographicField"
                  ></pie-chart>
                </chart-legend-wrap>
              </b-col>
            </b-row>
         </b-card>
        
        <b-card class='marginB-62'>
          <h4 class="card-title marginB-32">Demographics over Time</h4>
                  
          <b-form-group
            class='pillSelector'
            label-cols="4"
            label-text-align="center"

            label-size='lg'
            label-class='addpersonlabel'
            label='Group By'
            label-for='demographic'
            horizontal
          >
            <b-form-select
              size="lg"
              :options="biographicOptions"
              id='demographic'
              v-model='demographicByTimeField'
            >
            </b-form-select>
          </b-form-group>
            
              <!--
              <b-button-toolbar class="float-right">
                <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="demographicByTimeInterval" name="radiosBtn">
                <b-form-radio v-if="!hideDayGraphFilter" class="mx-0" value="Day" >Last 30 Days</b-form-radio>
                <b-form-radio v-if="!hideMonthGraphFilter" class="mx-0" value="All" >Month</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
              -->
    
          <!-- STACKED LINE CHARTS -->
          <div class='marginB-62'>
            <h4 class="card-title marginB-32">All People</h4>
            <chart-legend-wrap 
              v-if="!rptpersonDemographicsOverTimeError"
              type='stacked-line' 
              :apiData="rptpersonDemographicsOverTime"
              valueField="timeInterval"
              :demographicName="demographicByTimeField"
              :colorValues="colorValues">
              <stacked-line-chart
                class="chart-wrapper"
                style="height:200px;"
                height="200"
                chartName="Demographics over Time"
                :apiData="rptpersonDemographicsOverTime"
                valueField="timeInterval"
                :demographicName="demographicByTimeField"
                :colorValues="colorValues"
              ></stacked-line-chart>
            </chart-legend-wrap>
            <p v-if="rptpersonDemographicsOverTimeError">There is no data for this chart.</p>
          </div>

          <div class='marginB-62'>
            <h4 class="card-title marginB-32">Confirmed Victims</h4>
            <chart-legend-wrap
              v-if="!rptpersonDemographicsOverTimeConfirmedError"
              type='stacked-line'
              :apiData="rptpersonDemographicsOverTimeConfirmed"
              valueField="timeInterval"
              :demographicName="demographicByTimeField"
              :colorValues="colorValues">
              <stacked-line-chart
                class="chart-wrapper"
                style="height:200px;"
                height="200"
                chartName="Demographics over Time"
                :apiData="rptpersonDemographicsOverTimeConfirmed"
                valueField="timeInterval"
                :demographicName="demographicByTimeField"
                :colorValues="colorValues"
              ></stacked-line-chart>
            </chart-legend-wrap>
            <p v-if="rptpersonDemographicsOverTimeConfirmedError">There is no data for this chart.</p>
          </div>

          <div class='marginB-62'>
            <h4 class="card-title marginB-32">Others</h4>
            <chart-legend-wrap
              v-if="!rptpersonDemographicsOverTimeUnconfirmedError"
              type='stacked-line'
              :apiData="rptpersonDemographicsOverTimeUnconfirmed"
              valueField="timeInterval"
              :demographicName="demographicByTimeField"
              :colorValues="colorValues">
              <stacked-line-chart
                class="chart-wrapper"
                style="height:200px;"
                height="200"
                chartName="Demographics over Time"
                :apiData="rptpersonDemographicsOverTimeUnconfirmed"
                valueField="timeInterval"
                :demographicName="demographicByTimeField"
                :colorValues="colorValues"
              ></stacked-line-chart>
            </chart-legend-wrap>
            <p v-if="rptpersonDemographicsOverTimeUnconfirmedError">There is no data for this chart.</p>
          </div>
        </b-card>
      </b-tab>

      <b-tab title="CSE-IT">
        <div class='flexRowAlignCenter marginB-38'>
            <b-card class="text-white bg-info marginR-42">
              <div class='flexRowBetween'>
                 <h1>{{ rptgeneralCounts.cseitCount === null ? 0 : rptgeneralCounts.cseitCount }}</h1>
                <account-icon :size='45' />
              </div>
              <!--
              <div class="h1 text-muted text-right mb-4">
                <i class="icon-note"></i>
              </div>
              <div class="h1 mb-0"> {{ generalCounts.cseitCount === null ? 0 : generalCounts.cseitCount }} </div>
              -->
              <h6 class='weight-300 marginB0'>CSE-IT Screenings</h6>
              <h6 class='weight-300 marginB0'>{{ rptgeneralCounts.cseitCountAllPerson === null ? 0 : rptgeneralCounts.cseitCountAllPerson }} unique person(s)</h6>
            </b-card>
          
            <b-card class="clickable-card bg-secondary marginR-42" @click="goToNoConcern">
              <div class='flexRowBetween flexRowAlignBaseline'>
                <div class='flexRowAlignBaseline'>
                  <h1> {{ rptgeneralCounts.cseitCountNoConcern === null ? 0 : rptgeneralCounts.cseitCountNoConcern }}</h1>
                  <h5>({{ percentCseitNoconcern }}%)</h5>
                </div>
                  <img src="../../../static/img/pie-black.png" width='30' height='30' />
              </div>
              <!--
              <div class="h1 text-muted text-right mb-4">
                <i class="icon-pie-chart"></i>
              </div>
              <div><span class="h1 mb-0"> {{ generalCounts.cseitCountNoConcern === null ? 0 : generalCounts.cseitCountNoConcern }} </span><span class="text-muted">({{ percentCseitNoconcern }}%)</span></div>
              -->
              <h6 class='weight-300 marginB0'>No Concern</h6>
              <h6 class='weight-300 marginB0'>{{ rptgeneralCounts.cseitCountNoConcernPerson === null ? 0 : rptgeneralCounts.cseitCountNoConcernPerson }} unique person(s)</h6>
            </b-card>

            <b-card class="text-white bg-warning clickable-card marginR-42" @click="goToPossibleConcern">
              <div class='flexRowBetween flexRowAlignBaseline'>
                <div class='flexRowAlignBaseline'>
                  <h1>{{ rptgeneralCounts.cseitCountPossibleConcern === null ? 0 : rptgeneralCounts.cseitCountPossibleConcern }}</h1>
                  <h5>({{ percentCseitPossibleConcern }}%)</h5>
                </div>
                  <img src="../../../static/img/alarm-white.png" width='36.6' height='28.3' />
              </div>
              <!--
              <div class="h1 text-muted text-right mb-4">
                <i class="icon-pie-chart"></i>
              </div>
              <div><span class="h1 mb-0"> {{ generalCounts.cseitCountPossibleConcern === null ? 0 : generalCounts.cseitCountPossibleConcern }} </span><span class="text-muted">({{ percentCseitPossibleConcern }}%)</span></div>
              -->
              <h6 class='weight-300 marginB0'>Possible Concern</h6>
              <h6 class='weight-300 marginB0'>{{ rptgeneralCounts.cseitCountPossibleConcernPerson === null ? 0 : rptgeneralCounts.cseitCountPossibleConcernPerson }} unique person(s)</h6>
            </b-card>
          
            <b-card class="text-white bg-danger clickable-card" @click="goToClearConcern">
              <div class='flexRowBetween flexRowAlignBaseline'>
                <div class='flexRowAlignBaseline'>   
                  <h1>{{ rptgeneralCounts.cseitCountClearConcern === null ? 0 : rptgeneralCounts.cseitCountClearConcern }}</h1>
                  <h5>({{ percentCseitClearConcern }}%)</h5>
                </div>
                  <img src="../../../static/img/asterisk-white.png" width='28.83' height='30' />
                </div>
              <!--
              <div class="h1 text-muted text-right mb-4">
                <i class="icon-pie-chart"></i>
              </div>
              <div><span class="h1 mb-0"> {{ generalCounts.cseitCountClearConcern === null ? 0 : generalCounts.cseitCountClearConcern }} </span><span class="text-muted">({{ percentCseitClearConcern }}%)</span></div>
              -->
              <h6 class='weight-300 marginB0'>Clear Concern</h6>
              <h6 class='weight-300 marginB0'>{{ rptgeneralCounts.cseitCountClearConcernPerson === null ? 0 : rptgeneralCounts.cseitCountClearConcernPerson }} unique person(s)</h6>
            </b-card>
          </div>
        <!-- CSE-IT By Time -->
        <b-card>
            <h4 class="card-title marginB-32">Screenings over Time</h4>
              <!--
              <b-button-toolbar class="float-left">
                <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="cseitTimeInterval" name="radiosBtn">
                  <b-form-radio v-if="!hideDayGraphFilter" class="mx-0" value="Day" >Last 30 Days</b-form-radio>
                  <b-form-radio v-if="!hideMonthGraphFilter" class="mx-0" value="All" >Month</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
              -->
          
          <main-chart
            class="chart-wrapper"
            style="height:200px"
            height=200
            chartName="Screenings"
            :apiData="rptcseitCountsByTime"
            v-if="!rptcseitCountsByTimeError"
          >
          </main-chart>
          <p v-if="rptcseitCountsByTimeError">There is no data for this chart.</p>
        </b-card>

        <b-card class='marginB0 paddingB0'>
          <h4 class="card-title marginB-32">Demographics by Status</h4>
               
            <b-form-group
              class='pillSelector'
              label-cols="4"
              label-text-align="center"

              label-size='lg'
              label-class='addpersonlabel'
              label='Group By'
              label-for='cseitDemographic'
              horizontal
            >
              <b-form-select
                size="lg"
                :options="biographicOptions"
                id='cseitDemographic'
                v-model='cseitDemographicField'
              >
              </b-form-select>
            </b-form-group>

            <p v-if="rptcseitCountsByDemographicError || (
              rptcseitCountsByDemographic &&
              rptcseitCountsByDemographic.length <= 0
            )">There is no data for this chart.</p>

            <div v-else>
              <b-row class='flexRowAround marginB-62'>
                <b-col md="4">
                  <h4 class="text-center">All Screenings</h4>
                  <chart-legend-wrap
                    type='pie'
                    :apiData="rptcseitCountsByDemographic"
                    valueField="cseitCount"
                  >
                    <pie-chart
                      height='300'

                      chartName="Screenings"
                      :apiData="rptcseitCountsByDemographic"
                      valueField="cseitCount"
                      :groupedBy="cseitDemographicField"
                    ></pie-chart>
                  </chart-legend-wrap>
                </b-col>

                <b-col md="4">
                  <h4 class="text-center">No Concern</h4>
                  <chart-legend-wrap type='pie' :apiData="rptcseitCountsByDemographic" valueField="cseitCountNoConcern">
                    <pie-chart
                    height='300'
                      chartName="No Concern"
                      :apiData="rptcseitCountsByDemographic"
                      valueField="cseitCountNoConcern"
                      :groupedBy="cseitDemographicField"
                    ></pie-chart>
                  </chart-legend-wrap>
                </b-col>
              </b-row>

              <b-row class='flexRowAround marginB-62'>
                <b-col md="4">
                  <h4 class="text-center">Possible Concern</h4>
                  <chart-legend-wrap type='pie' :apiData="rptcseitCountsByDemographic" valueField="cseitCountPossibleConcern">
                    <pie-chart
                    height='300'
                      chartName="Possible Concern"
                      :apiData="rptcseitCountsByDemographic"
                      valueField="cseitCountPossibleConcern"
                      :groupedBy="cseitDemographicField"
                    ></pie-chart>
                  </chart-legend-wrap>
                </b-col>

                <b-col md="4">
                  <h4 class="text-center">Clear Concern</h4>
                  <chart-legend-wrap type='pie' :apiData="rptcseitCountsByDemographic" valueField="cseitCountClearConcern">
                    <pie-chart
                    height='300'
                      chartName="Clear Concern"
                      :apiData="rptcseitCountsByDemographic"
                      valueField="cseitCountClearConcern"
                      :groupedBy="cseitDemographicField"
                    ></pie-chart>
                  </chart-legend-wrap>
                </b-col>
              </b-row>
            </div>
         </b-card>
        
        <b-card>
          <h4 class="card-title marginB-32">Demographics over Time</h4>
            <b-form-group
              class='pillSelector'
              label-cols="4"
              label-text-align="center"

              label-size='lg'
              label-class='addpersonlabel'
              label='Group By'
              label-for='demographic'
              horizontal
            >
              <b-form-select
                size="lg"
                :options="biographicOptions"
                id='demographic'
                v-model='cseitDemographicByTimeField'
              >
              </b-form-select>
            </b-form-group>
              <!--
              <b-button-toolbar class="float-right">
                <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="cseitDemographicByTimeInterval" name="radiosBtn">
                <b-form-radio v-if="!hideDayGraphFilter" class="mx-0" value="Day" >Last 30 Days</b-form-radio>
                <b-form-radio v-if="!hideMonthGraphFilter" class="mx-0" value="All" >Month</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
              -->
            
          <!-- Stacked Line Charts -->
          <div class='marginB-62'>
            <h4 class="card-title marginB-32">All Screenings</h4>
            <chart-legend-wrap v-if="!rptcseitDemographicsByTimeError" type='stacked-line' :apiData="rptcseitDemographicsByTime" valueField="timeInterval" :demographicName="cseitDemographicByTimeField" :colorValues="colorValues">
              <stacked-line-chart
                class="chart-wrapper"
                style="height:200px"
                height="200"
                chartName="Demographics over Time"
                :apiData="rptcseitDemographicsByTime"
                valueField="timeInterval"
                :demographicName="cseitDemographicByTimeField"
                :colorValues="colorValues"
              ></stacked-line-chart>
            </chart-legend-wrap>
            <p v-if="rptcseitDemographicsByTimeError">There is no data for this chart.</p>
          </div>

          <div class='marginB-62'>
            <h4 class="card-title marginB-32">No Concern</h4>
            <chart-legend-wrap v-if="!rptcseitDemographicsOverTimeNoConcernError" type='stacked-line' :apiData="rptcseitDemographicsByTimeNoConcern" valueField="timeInterval" :demographicName="cseitDemographicByTimeField" :colorValues="colorValues">
              <stacked-line-chart
                class="chart-wrapper"
                style="height:200px"
                height="200"
                chartName="Demographics over Time"
                :apiData="rptcseitDemographicsByTimeNoConcern"
                valueField="timeInterval"
                :demographicName="cseitDemographicByTimeField"
                :colorValues="colorValues"
              ></stacked-line-chart>
            </chart-legend-wrap>
            <p v-if="rptcseitDemographicsOverTimeNoConcernError">There is no data for this chart.</p>
          </div>

          <div class='marginB-62'>
            <h4 class="card-title marginB-32">Possible Concern</h4>
              <chart-legend-wrap
                v-if="!rptcseitDemographicsOverTimePossibleConcernError" type='stacked-line' :apiData="rptcseitDemographicsByTimePossibleConcern" valueField="timeInterval" :demographicName="cseitDemographicByTimeField" :colorValues="colorValues"
              >
              <stacked-line-chart
                class="chart-wrapper"
                style="height:200px"
                height="200"
                chartName="Demographics over Time"
                :apiData="rptcseitDemographicsByTimePossibleConcern"
                valueField="timeInterval"
                :demographicName="cseitDemographicByTimeField"
                :colorValues="colorValues"
              ></stacked-line-chart>
            </chart-legend-wrap>
            <p v-if="rptcseitDemographicsOverTimePossibleConcernError">There is no data for this chart.</p>
          </div>

          <div class='marginB-62'>
            <h4 class="card-title marginB-32">Clear Concern</h4>
            <chart-legend-wrap
              v-if="!rptcseitDemographicsOverTimeClearConcernError" type='stacked-line' :apiData="rptcseitDemographicsByTimeClearConcern" valueField="timeInterval" :demographicName="cseitDemographicByTimeField" :colorValues="colorValues"
            >
              <stacked-line-chart
                class="chart-wrapper"
                style="height:200px"
                height="200"
                chartName="Demographics over Time"
                :apiData="rptcseitDemographicsByTimeClearConcern"
                valueField="timeInterval"
                :demographicName="cseitDemographicByTimeField"
                :colorValues="colorValues"
              ></stacked-line-chart>
            </chart-legend-wrap>
            <p v-if="rptcseitDemographicsOverTimeClearConcernError">There is no data for this chart.</p>
          </div>
        </b-card>

        <b-card>
          <h4 class="card-title mb-0">Indicators</h4>
              
          <b-row class="justify-content-center">
              <b-form-group
                label-for='demographic'
                horizontal
                style="width:400px"
              >
                <b-form-select
                  size="lg"
                  :options="cseitIndicatorOptions"
                  id='demographic'
                  v-model='cseitIndicatorOption'
                >
                </b-form-select>
              </b-form-group>
          </b-row>
          <b-row>
            <b-col sm="12">
              <horizontal-bar-chart
                :apiData="rptCseitIndicators"
                v-if="!rptCseitIndicatorsError"
              >
              </horizontal-bar-chart>
              <p v-if="rptCseitIndicatorsError">There is no data for this chart.</p>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>

      <b-tab title="Lighthouse Indicators">
        <b-row class='marginB-14'>
          <b-col sm="12" md="3" class='padding0 marginR-42'>
            <b-card class="text-white bg-info marginR-42">
              <div class='flexRowBetween'>
                  <h1>{{ rptgeneralCounts.assessmentCount === null ? 0 : rptgeneralCounts.assessmentCount }}</h1>
                  <account-icon :size='45' />
                </div>
              <h6 class='weight-300 marginB0'>All Lighthouse Screenings</h6>
              <h6 class='weight-300 marginB0'>{{ rptgeneralCounts.assessmentCountAllPerson === null ? 0 : rptgeneralCounts.assessmentCountAllPerson }} unique person(s)</h6>
            </b-card>
          </b-col>

          <b-col sm="12" md="3" class='padding0 marginR-42'>
            <b-card class='bg-secondary marginR-42'>
              <div class='flexRowBetween flexRowAlignBaseline'>
                <div class='flexRowAlignBaseline'>
                  <h1>{{ rptgeneralCounts.assessmentCountNotEnoughInfo  === null ? 0 : rptgeneralCounts.assessmentCountNotEnoughInfo }}</h1>
                  <h5>({{ percentAssessmentNotenoughinfo }}%)</h5>
                </div>
                  <img src="../../../static/img/pie-black.png" width='30' height='30' />
                </div>
              <h6 class='weight-300 marginB0'>Not Enough Info</h6>
              <h6 class='weight-300 marginB0'> {{ rptgeneralCounts.assessmentCountNotEnoughInfoPerson === null ? 0 : rptgeneralCounts.assessmentCountNotEnoughInfoPerson }} unique person(s)</h6>
            </b-card>
          </b-col>

          <b-col sm="12" md="3" class='padding0'>
            <b-card class="text-white bg-warning">
              <div class='flexRowBetween flexRowAlignBaseline'>
                <div class='flexRowAlignBaseline'>    
                  <h1>{{ rptgeneralCounts.assessmentCountPossible === null ? 0 : rptgeneralCounts.assessmentCountPossible }}</h1>
                  <h5>({{ percentAssessmentPossible }}%)</h5>
                </div>
                  <img src="../../../static/img/alarm-white.png" width='36.6' height='28.3' />
                </div>
              <h6 class='weight-300 marginB0'>Possible Victim</h6>
              <h6 class='weight-300 marginB0'>{{ rptgeneralCounts.assessmentCountPossiblePerson === null ? 0 : rptgeneralCounts.assessmentCountPossiblePerson }} unique person(s)</h6>
            </b-card>
          </b-col>
        </b-row>

        <!-- Assessments By Time -->
        <b-card class='marginB-14'>
          <h4 class="card-title marginB-32">Lighthouse Screenings over Time</h4>
              
              <!--
              <b-button-toolbar class="float-left">
                <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="assessmentsTimeInterval" name="radiosBtn">
                  <b-form-radio v-if="!hideDayGraphFilter" class="mx-0" value="Day" >Last 30 Days</b-form-radio>
                  <b-form-radio v-if="!hideMonthGraphFilter" class="mx-0" value="All" >Month</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
              -->
          <main-chart
            class="chart-wrapper"
            style="height:200px;"
            height="200"
            chartName="Assessments"
            :apiData="rptassessmentCountsByTime"
            v-if="!rptassessmentCountsByTimeError"
          >
          </main-chart>
          <p v-if="rptassessmentCountsByTimeError">There is no data for this chart.</p>
        </b-card>

        <b-card class='marginB-14'> 
          <h4 class="card-title marginB-32">Demographics by Status</h4>
                
            <b-form-group
            class='pillSelector'
            label-cols="4"
            label-text-align="center"

              label-size='lg'
              label-class='addpersonlabel'
              label='Group By'
              label-for='demographic'
              horizontal
            >
              <b-form-select
                size="lg"
                :options="biographicOptions"
                id='demographic'
                v-model='assessmentDemographicField'
              >
              </b-form-select>
            </b-form-group>
            <p v-if="rptassessmentByDemographicError">There is no data for this chart.</p>

            <b-row v-if="!rptassessmentByDemographicError">
              <b-col sm="4">
                <h4 class="text-center">All Lighthouse Screenings</h4>
                <chart-legend-wrap type='pie' :apiData="rptassessmentCountsByDemographic" valueField="assessmentCount">
                  <pie-chart
                    height='300'

                    class="chart-wrapper"
                    chartName="Total People"
                    :apiData="rptassessmentCountsByDemographic"
                    valueField="assessmentCount"
                    :groupedBy="assessmentDemographicField"
                  ></pie-chart>
                </chart-legend-wrap>
              </b-col>

              <b-col sm="4">
                <h4 class="text-center">Not Enough Information</h4>
                <chart-legend-wrap type='pie' :apiData="rptassessmentCountsByDemographic" valueField="assessmentCountNotEnoughInfo">
                  <pie-chart
                    height='300'

                    class="chart-wrapper"
                    chartName="Possible Victims"
                    :apiData="rptassessmentCountsByDemographic"
                    valueField="assessmentCountNotEnoughInfo"
                    :groupedBy="assessmentDemographicField"
                  ></pie-chart>
                </chart-legend-wrap>
              </b-col>

              <b-col sm="4">
                <h4 class="text-center">Possible Victim</h4>
                <chart-legend-wrap type='pie' :apiData="rptassessmentCountsByDemographic" valueField="assessmentCountPossible">
                  <pie-chart
                    height='300'

                    class="chart-wrapper"
                    chartName="Confirmed Victims"
                    :apiData="rptassessmentCountsByDemographic"
                    valueField="assessmentCountPossible"
                    :groupedBy="assessmentDemographicField"
                  ></pie-chart>
                </chart-legend-wrap>
              </b-col>
            </b-row>
         </b-card>
        
        <b-card class='marginB-14'>
          <h4 class="card-title marginB-32">Demographics over Time</h4>
                  
              <b-form-group
                class='pillSelector'
                label-cols="4"
                label-text-align="center"

                label-size='lg'
                label-class='addpersonlabel'
                label='Group By'
                label-for='demographic'
                horizontal
              >
                <b-form-select
                  size="lg"
                  :options="biographicOptions"
                  id='demographic'
                  v-model='assessmentDemographicByTimeField'
                >
                </b-form-select>
              </b-form-group>
            
              <!--
              <b-button-toolbar class="float-right">
                <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="assessmentDemographicByTimeInterval" name="radiosBtn">
                <b-form-radio v-if="!hideDayGraphFilter" class="mx-0" value="Day" >Last 30 Days</b-form-radio>
                <b-form-radio v-if="!hideMonthGraphFilter" class="mx-0" value="All" >Month</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
              -->
          <div class='marginB-62'>
            <h4 class="card-title marginB-32">All Lighthouse Screenings</h4>
            <chart-legend-wrap
              v-if="!rptassessmentDemographicsByTimeError"
              type='stacked-line'
              :apiData="rptassessmentDemographicsByTime"
              valueField="timeInterval"
              :demographicName="assessmentDemographicByTimeField"
              :colorValues="colorValues">
              <stacked-line-chart
                class="chart-wrapper"
                style="height:200px;"
                height="200"
                chartName="Demographics over Time"
                :apiData="rptassessmentDemographicsByTime"
                valueField="timeInterval"
                :demographicName="assessmentDemographicByTimeField"
                :colorValues="colorValues"
              ></stacked-line-chart>
            </chart-legend-wrap>
            <p v-if="rptassessmentDemographicsByTimeError">There is no data for this chart.</p>
          </div>

          <div class='marginB-62'>
            <h4 class="card-title marginB-32">Not Enough Information</h4>
            <chart-legend-wrap v-if="!rptassessmentDemographicsOverTimeNoInfoError" 
            type='stacked-line'
            :apiData="rptassessmentDemographicsByTimeNoInfoVictims"
            valueField="timeInterval"
            :demographicName="assessmentDemographicByTimeField"
            :colorValues="colorValues">
              <stacked-line-chart
                class="chart-wrapper"
                style="height:200px;"
                height="200"
                chartName="Demographics over Time"
                :apiData="rptassessmentDemographicsByTimeNoInfoVictims"
                valueField="timeInterval"
                :demographicName="assessmentDemographicByTimeField"
                :colorValues="colorValues"
              ></stacked-line-chart>
            </chart-legend-wrap>
            <p v-if="rptassessmentDemographicsOverTimeNoInfoError">There is no data for this chart.</p>
          </div>
          
          <h4 class="card-title marginB-32">Possible Victim</h4>
          <chart-legend-wrap
            v-if="!rptassessmentDemographicsOverTimePossibleError"
            type='stacked-line'
            :apiData="rptassessmentDemographicsByTimePossibleVictims"
            valueField="timeInterval"
            :demographicName="assessmentDemographicByTimeField"
            :colorValues="colorValues">
            <stacked-line-chart
              class="chart-wrapper"
              style="height:200px;"
              height="200"
              chartName="Demographics over Time"
              :apiData="rptassessmentDemographicsByTimePossibleVictims"
              valueField="timeInterval"
              :demographicName="assessmentDemographicByTimeField"
              :colorValues="colorValues"
            ></stacked-line-chart>
          </chart-legend-wrap>
          <p v-if="rptassessmentDemographicsOverTimePossibleError">There is no data for this chart.</p>
        </b-card>
        
        <b-card>
          <h4 class="card-title mb-0">Indicators</h4>
            
          <div class='flexRowJustifyCenter'>
            <b-form-group
              label-for='demographic'
              horizontal
              style="width:450px"
            >
              <b-form-select
                size="lg"
                :options="assessmentIndicatorOptions"
                id='demographic'
                v-model='assessmentIndicatorOption'
              >
              </b-form-select>
            </b-form-group>
          </div>

          <b-row>
            <b-col sm="12">
              <horizontal-bar-chart
                :apiData="rptassessmentIndicators"
                v-if="!rptassessmentIndicatorsError"
              >
              </horizontal-bar-chart>
              <p v-if="rptassessmentIndicatorsError">There is no data for this chart.</p>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>

      <b-tab title="Labor Screening">
        <!-- Labor Screening Count Cards -->
        <div class='flexRowAlignCenter marginB-38'>
          <b-card class="text-white bg-info marginR-42">
            <div class='flexRowBetween'>
              <h1>{{ rptgeneralCounts.lsCount }}</h1>
              <account-icon :size='45' />
            </div>
            <h6 class='weight-300 marginB0'>Labor Screenings</h6>
            <h6 class='weight-300 marginB0'>{{ rptgeneralCounts.lsCountAllPerson }} unique person(s)</h6>
          </b-card>
          
          <b-card class="clickable-card bg-secondary marginR-42" @click="goToLSNotEnoughInfo">
            <div class='flexRowBetween flexRowAlignBaseline'>
              <div class='flexRowAlignBaseline'>
                <h1>{{ rptgeneralCounts.lsCountNotEnoughInfo }}</h1>
                <h5>({{ percentLsNotEnoughInfo }}%)</h5>
              </div>
              <img src="../../../static/img/pie-black.png" width='30' height='30' />
            </div>
            <h6 class='weight-300 marginB0'>Not Enough Info</h6>
            <h6 class='weight-300 marginB0'>{{ rptgeneralCounts.lsCountNotEnoughInfoPerson }} unique person(s)</h6>
          </b-card>
          
          <b-card class="text-white bg-warning clickable-card marginR-42" @click="goToLSVulnerable">
            <div class='flexRowBetween flexRowAlignBaseline'>
              <div class='flexRowAlignBaseline'>  
                <h1>{{ rptgeneralCounts.lsCountVulnerable }}</h1>
                <h5>({{ percentLsVulnerable }}%)</h5>
              </div>
              <img src="../../../static/img/alarm-white.png" width='36.6' height='28.3' />
            </div>
            <h6 class='weight-300 marginB0'>Level 1: Concern</h6>
            <h6 class='weight-300 marginB0'>{{ rptgeneralCounts.lsCountVulnerablePerson }} unique person(s)</h6>
          </b-card>
          
          <b-card class="text-white bg-danger clickable-card" @click="goToLSHighlyVulnerable">
            <div class='flexRowBetween flexRowAlignBaseline'>
              <div class='flexRowAlignBaseline'> 
                <h1>{{ rptgeneralCounts.lsCountHighlyVulnerable }}</h1>
                <h5>({{ percentLsHighlyVulnerable }}%)</h5>
              </div>
              <img src="../../../static/img/asterisk-white.png" width='28.83' height='30' />
            </div>
            <h6 class='weight-300 marginB0'>Level 2: Indicated</h6>
            <h6 class='weight-300 marginB0'>{{ rptgeneralCounts.lsCountHighlyVulnerablePerson }} unique person(s)</h6>
          </b-card>
        </div>
          
        <!-- Labor Screening By Time -->
        <b-card class='marginB-14'>
          <h4 class="card-title marginB-32">Screenings over Time</h4>
              
          <main-chart
            v-if="!rptLaborScreeningCountsByTimeError"
            class="chart-wrapper"
            style="height:200px;"
            height=200
            chartName="Screenings"
            :apiData="rptLaborScreeningCountsByTime"
          />
          <p v-else>There is no data for this chart.</p>
        </b-card>
        <!-- Labor Screenings By Demographic -->
        <b-card class='marginB-14'>
          <h4 class="card-title marginB-32">Demographics by Status</h4>
             
          <b-form-group
            class='pillSelector'
            label-cols="4"

            label-size='lg'
            label-text-align="left"
            label-class='addpersonlabel'
            label='Group By'
            label-for='laborScreeningDemographic'
            horizontal
          >
            <b-form-select
              size="lg"
              :options="biographicOptions"
              id='laborScreeningDemographic'
              v-model='laborScreeningDemographicField'
            >
            </b-form-select>
          </b-form-group>
          <p
            v-if="rptLaborScreeningCountsByDemographicError || (
              rptLaborScreeningCountsByDemographic &&
              rptLaborScreeningCountsByDemographic.length <= 0
            )"
          >There is no data for this chart.</p>

          <div v-else>
            <b-row class='flexRowAround marginB-62'>
              <b-col md='4'>
                <h4 class="text-center">All Screenings</h4>
                <chart-legend-wrap 
                  type='pie' 
                  :apiData="rptLaborScreeningCountsByDemographic" 
                  valueField="lsCount"
                >
                  <pie-chart
                    height='300'

                    chartName="Screenings"
                    :apiData="rptLaborScreeningCountsByDemographic"
                    valueField="lsCount"
                    :groupedBy="laborScreeningDemographicField"
                  ></pie-chart>
                </chart-legend-wrap>
              </b-col>

              <b-col md='4'>
                <h4 class="text-center">Not Enough Info</h4>
                <chart-legend-wrap 
                  type='pie' 
                  :apiData="rptLaborScreeningCountsByDemographic"
                  valueField="lsCountNotEnoughInfo"
                >
                  <pie-chart
                    height='300'

                    chartName="Not Enough Info"
                    :apiData="rptLaborScreeningCountsByDemographic"
                    valueField="lsCountNotEnoughInfo"
                    :groupedBy="laborScreeningDemographicField"
                  ></pie-chart>
                </chart-legend-wrap>
              </b-col>
            </b-row>

            <b-row class='flexRowAround'>
              <b-col md='4'>
                <h4 class="text-center">Level 1: Concern</h4>
                <chart-legend-wrap 
                  type='pie' 
                  :apiData="rptLaborScreeningCountsByDemographic"
                  valueField="lsCountVulnerable"
                >
                  <pie-chart
                    height='300'

                    chartName="Level 1: Concern"
                    :apiData="rptLaborScreeningCountsByDemographic"
                    valueField="lsCountVulnerable"
                    :groupedBy="laborScreeningDemographicField"
                  ></pie-chart>
                </chart-legend-wrap>
              </b-col>

              <b-col md='4'>
                <h4 class="text-center">Level 2: Indicated</h4>
                <chart-legend-wrap 
                  type='pie' 
                  :apiData="rptLaborScreeningCountsByDemographic"
                  valueField="lsCountHighlyVulnerable"
                >
                  <pie-chart
                    height='300'

                    chartName="Level 2: Indicated"
                    :apiData="rptLaborScreeningCountsByDemographic"
                    valueField="lsCountHighlyVulnerable"
                    :groupedBy="laborScreeningDemographicField"
                  ></pie-chart>
                </chart-legend-wrap>
              </b-col>
            </b-row>
          </div>
        </b-card>
        
        <b-card class='marginB-14'>
          <h4 class="card-title marginB-32">Demographics over Time</h4>
                
          <b-form-group
            class='pillSelector'
            label-cols="4"
            label-text-align="center"

            label-size='lg'
            label-class='addpersonlabel'
            label='Group By'
            label-for='demographic'
            horizontal
            style="width:400px"
          >
            <b-form-select
              size="lg"
              :options="biographicOptions"
              id='demographic'
              v-model='laborScreeningDemographicByTimeField'
            >
            </b-form-select>
          </b-form-group>
           
            <!-- Stacked Line Charts -->
          <div class='marginB-62'>
            <h4 class="card-title marginB-32">All Screenings</h4>
            <chart-legend-wrap 
            v-if="!rptLaborScreeningDemographicsByTimeError" 
            type='stacked-line'
            :apiData="rptLaborScreeningDemographicsByTime"
            valueField="timeInterval"
            :demographicName="laborScreeningDemographicByTimeField"
            :colorValues="colorValues"
            >
              <stacked-line-chart
                class="chart-wrapper"
                style="height:200px;"
                height="200"
                chartName="Demographics over Time"
                :apiData="rptLaborScreeningDemographicsByTime"
                valueField="timeInterval"
                :demographicName="laborScreeningDemographicByTimeField"
                :colorValues="colorValues"
              ></stacked-line-chart>
            </chart-legend-wrap>
            <p v-else>There is no data for this chart.</p>
          </div>
            
          <div class='marginB-62'>
            <h4 class="card-title marginB-32">Not Enough Info</h4>
            <chart-legend-wrap 
              v-if="!rptLaborScreeningDemographicsByTimeError"
              type='stacked-line'
              :apiData="rptLaborScreeningDemographicsByTime"
              valueField="timeInterval"
              :demographicName="laborScreeningDemographicByTimeField"
              demographicTotalKey="demographicNotEnoughInfo"
              :colorValues="colorValues"
            >
              <stacked-line-chart
                class="chart-wrapper"
                style="height:200px;"
                height="200"
                chartName="Demographics over Time"
                :apiData="rptLaborScreeningDemographicsByTime"
                valueField="timeInterval"
                :demographicName="laborScreeningDemographicByTimeField"
                demographicTotalKey="demographicNotEnoughInfo"
                :colorValues="colorValues"
              ></stacked-line-chart>
            </chart-legend-wrap>
            <p v-else>There is no data for this chart.</p>
            </div>

            <div class='marginB-62'>
              <h4 class="card-title marginB-32">Level 1: Concern</h4>
              <chart-legend-wrap 
                v-if="!rptLaborScreeningDemographicsByTimeError"
                type='stacked-line'
                :apiData="rptLaborScreeningDemographicsByTime"
                valueField="timeInterval"
                :demographicName="laborScreeningDemographicByTimeField"
                demographicTotalKey="demographicVulnerable"
                :colorValues="colorValues"
              >
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="rptLaborScreeningDemographicsByTime"
                  valueField="timeInterval"
                  :demographicName="laborScreeningDemographicByTimeField"
                  demographicTotalKey="demographicVulnerable"
                  :colorValues="colorValues"
                ></stacked-line-chart>
              </chart-legend-wrap>
              <p v-else>There is no data for this chart.</p>
            </div>

            <div>
              <h4 class="card-title mb-0">Level 2: Indicated</h4>
              <chart-legend-wrap
                v-if="!rptLaborScreeningDemographicsByTimeError"
                type='stacked-line'
                :apiData="rptLaborScreeningDemographicsByTime"
                valueField="timeInterval"
                :demographicName="laborScreeningDemographicByTimeField"
                demographicTotalKey="demographicHighlyVulnerable"
                :colorValues="colorValues"
              >
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="rptLaborScreeningDemographicsByTime"
                  valueField="timeInterval"
                  :demographicName="laborScreeningDemographicByTimeField"
                  demographicTotalKey="demographicHighlyVulnerable"
                  :colorValues="colorValues"
                ></stacked-line-chart>
              </chart-legend-wrap>
              <p v-else>There is no data for this chart.</p>
            </div>
        </b-card>
        
        <b-card>
          <h4 class="card-title mb-0">Indicators</h4>
              
          <b-row class="justify-content-center">
              <b-form-group
                label-for='demographic'
                horizontal
                style="width:420px"
              >
                <b-form-select
                  size="lg"
                  :options="laborScreeningIndicatorOptions"
                  id='demographic'
                  v-model='laborScreeningIndicatorOption'
                >
                </b-form-select>
              </b-form-group>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-tabs>
                <b-tab title="Ends">
                  <horizontal-bar-chart
                    v-if="(
                      !rptLaborScreeningIndicatorsError &&
                      rptLaborScreeningIndicatorsEnds &&
                      rptLaborScreeningIndicatorsEnds.length
                    )"
                    :transformKeyFunction="transformLaborScreeningIndicatorKey"
                    :apiData="rptLaborScreeningIndicatorsEnds"
                  />
                  <p v-else>There is no data for this chart.</p>
                </b-tab>
                <b-tab title="Means">
                  <horizontal-bar-chart
                    v-if="(
                      !rptLaborScreeningIndicatorsError &&
                      rptLaborScreeningIndicatorsMeans &&
                      rptLaborScreeningIndicatorsMeans.length
                    )"
                    :transformKeyFunction="transformLaborScreeningIndicatorKey"
                    :apiData="rptLaborScreeningIndicatorsMeans"
                  />
                  <p v-else>There is no data for this chart.</p>
                </b-tab>
                <b-tab title="Process">
                  <horizontal-bar-chart
                    v-if="(
                      !rptLaborScreeningIndicatorsError &&
                      rptLaborScreeningIndicatorsProcess &&
                      rptLaborScreeningIndicatorsProcess.length
                    )"
                    :transformKeyFunction="transformLaborScreeningIndicatorKey"
                    :apiData="rptLaborScreeningIndicatorsProcess"
                  />
                  <p v-else>There is no data for this chart.</p>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import HorizontalBarChart from '../charts/HorizontalBarChart'
import MainChart from '../charts/MainChart'
import ChartLegendWrap from '../charts/ChartLegendWrap'
import PieChart from '../charts/PieChart'
// import StackedBarChart from '../charts/StackedBarChart'
import StackedLineChart from '../charts/StackedLineChart'
import JsonCSV from 'vue-json-csv'
import AssessmentIndicatorsTile from '../charts/AssessmentIndicators'
import AssessmentIndicatorsComparison from '../charts/AssessmentIndicatorsComparison'

import { mapGetters } from 'vuex'
import { LABOR_SCREENING_CONCLUSION, GLOBAL_REPORTS_TAB_INDEX } from '../../helpers/enums'

export default {
  name: 'reports',
  components: {
    HorizontalBarChart,
    MainChart,
    ChartLegendWrap,
    PieChart,
    AssessmentIndicatorsTile,
    AssessmentIndicatorsComparison,
    // StackedBarChart,
    StackedLineChart,
    'download-csv': JsonCSV
  },
  computed: {
    ...mapGetters({
      biographicOptions: 'getPersonBiographicOptions',
      rptassessmentIndicators: 'getReportAssessmentIndicators',
      rptassessmentIndicatorsByPerson: 'getReportAssessmentIndicatorsByPerson',
      rptgeneralCounts: 'getReportGeneralCounts',
      rptassessmentCountsByTime: 'getReportAssessmentCountsByTime',
      rptpersonCountsByTime: 'getReportPersonCountsByTime',
      rptpersonCountsByDemographic: 'getPersonCountsByDemographic',
      rptPersonCountsByDemographic: 'getReportPersonCountsByDemographic',
      rptcseitCountsByIndicators: 'getReportCseitCountsByIndicators',
      assessmentFields: 'getAssessmentFields',
      assessmentIndicatorOptions: 'getAssessmentIndicatorOptions',
      rptcseitCountsByTime: 'getReportCseitCountsByTime',
      rptLaborScreeningCountsByTime: 'getRptLaborScreeningCountsByTime',
      rptLaborScreeningCountsByTimeError: 'getRptLaborScreeningCountsByTimeError',
      rptLaborScreeningCountsByDemographic: 'getRptLaborScreeningCountsByDemographic',
      rptLaborScreeningCountsByDemographicError: 'getRptLaborScreeningCountsByDemographicError',
      rptLaborScreeningDemographicsByTime: 'getRptLaborScreeningDemographicsByTime',
      rptLaborScreeningDemographicsByTimeError: 'getRptLaborScreeningDemographicsByTimeError',
      rptLaborScreeningIndicators: 'getRptLaborScreeningIndicators',
      rptLaborScreeningIndicatorsError: 'getRptLaborScreeningIndicatorsError',
      rptpersonDemographicsOverTime: 'getReportPersonDemographicsOverTime',
      rptpersonDemographicsOverTimeUnconfirmed: 'getReportPersonDemographicsOverTimeUnconfirmed',
      rptpersonDemographicsOverTimeConfirmed: 'getReportPersonDemographicsOverTimeConfirmed',
      rptcseitCountsByDemographic: 'getReportCseitCountsByDemographic',
      rptassessmentCountsByDemographic: 'getReportAssessmentCountsByDemographic',
      rptcseitDemographicsByTime: 'getReportCseitDemographicsByTime',
      rptcseitDemographicsByTimeNoConcern: 'getReportCseitDemographicsByTimeNoConcern',
      rptcseitDemographicsByTimePossibleConcern: 'getReportCseitDemographicsByTimePossibleConcern',
      rptcseitDemographicsByTimeClearConcern: 'getReportCseitDemographicsByTimeClearConcern',
      rptassessmentDemographicsByTime: 'getReportAssessmentDemographicsByTime',
      rptassessmentDemographicsByTimeNoInfoVictims: 'getReportAssessmentDemographicsByTimeNoInfoVictims',
      rptassessmentDemographicsByTimePossibleVictims: 'getReportAssessmentDemographicsByTimePossibleVictims',
      rptCseitIndicators: 'getReportCseitIndicators',
      cseitIndicatorOptions: 'getCseitIndicatorOptions',
      laborScreeningIndicatorOptions: 'getLaborScreeningIndicatorOptions',
      colorValues: 'getColorValues',
      rptpersonDemographicsOverTimeError: 'getReportPersonDemographicsOverTimeError',
      rptpersonCountsByTimeError: 'getReportPersonCountsByTimeError',
      rptPersonCountsByDemographicError: 'getReportPersonCountsByDemographicError',
      rptpersonDemographicsOverTimeUnconfirmedError: 'getReportPersonDemographicsOverTimeUnconfirmedError',
      rptpersonDemographicsOverTimeConfirmedError: 'getReportPersonDemographicsOverTimeConfirmedError',
      rptcseitCountsByTimeError: 'getReportCseitCountsByTimeError',
      rptcseitCountsByDemographicError: 'getReportCseitCountsByDemographicError',
      rptcseitDemographicsByTimeError: 'getReportCseitDemographicsByTimeError',
      rptcseitDemographicsOverTimeNoConcernError: 'getReportCseitDemographicsOverTimeNoConcernError',
      rptcseitDemographicsOverTimePossibleConcernError: 'getReportCseitDemographicsOverTimePossibleConcernError',
      rptcseitDemographicsOverTimeClearConcernError: 'getReportCseitDemographicsOverTimeClearConcernError',
      rptassessmentCountsByTimeError: 'getReportAssessmentCountsByTimeError',
      rptassessmentByDemographicError: 'getReportAssessmentByDemographicError',
      rptassessmentDemographicsByTimeError: 'getReportAssessmentDemographicsByTimeError',
      rptassessmentDemographicsOverTimeNoInfoError: 'getReportAssessmentDemographicsOverTimeNoInfoError',
      rptassessmentDemographicsOverTimePossibleError: 'getReportAssessmentDemographicsOverTimePossibleError',
      rptassessmentIndicatorsError: 'getReportAssessmentIndicatorsError',
      rptCseitIndicatorsError: 'getReportCseitIndicatorsError',
      allUsers: 'getAllUsers',
      allOrgs: 'getAllOrgs',
      allGroups: 'getGroups',
      allLogs: 'getAllLogs',
      screeningsByOrg: 'getScreeningsByOrg',
      laborScreeningsByOrg: 'getLaborScreeningsByOrg',
      locationFilterOptions: 'getLocationFilterOptions',
      laborScreeningFields: 'getLaborScreeningFields'
    }),
    rptLaborScreeningIndicatorsEnds () {
      return this.rptLaborScreeningIndicators.filter(({ field }) => field.startsWith('e_'))
    },
    rptLaborScreeningIndicatorsMeans () {
      return this.rptLaborScreeningIndicators.filter(({ field }) => field.startsWith('m_'))
    },
    rptLaborScreeningIndicatorsProcess () {
      return this.rptLaborScreeningIndicators.filter(({ field }) => field.startsWith('p_'))
    }
  },
  watch: {
    tabIndex (newValue) {
      if (this.hasVisitedTabMap[newValue]) {
        return
      }

      this.hasVisitedTabMap[newValue] = true
      this.fetchStatsByTab(newValue)
    },

    statisticsTimeInterval: function (newValue) {
      if (newValue) {
        this.fetchStats()
      }
    },

    locationFilter: function (newValue) {
      if (newValue) {
        this.fetchStats()
      }
    },

    rptgeneralCounts: function (newValue) {
      if (newValue) {
        if (newValue.personCount === 0) {
          this.percentUnconfirmedPersons = 0
          this.percentConfirmedPersons = 0
        } else {
          this.percentUnconfirmedPersons = Math.round(newValue.possiblePersonCount / newValue.personCount * 100)

          if (newValue.confirmedPersonCount === null) {
            this.percentConfirmedPersons = Math.round(0 / newValue.personCount * 100)
          } else {
            this.percentConfirmedPersons = Math.round(newValue.confirmedPersonCount / newValue.personCount * 100)
          }
        }

        if (newValue.cseitCount === 0) {
          this.percentCseitNoconcern = 0
          this.percentCseitPossibleConcern = 0
          this.percentCseitClearConcern = 0
        } else {
          this.percentCseitNoconcern = Math.round(newValue.cseitCountNoConcern / newValue.cseitCount * 100)
          this.percentCseitPossibleConcern = Math.round(newValue.cseitCountPossibleConcern / newValue.cseitCount * 100)
          this.percentCseitClearConcern = Math.round(newValue.cseitCountClearConcern / newValue.cseitCount * 100)
        }

        if (newValue.assessmentCount === 0) {
          this.percentAssessmentNotenoughinfo = 0
          this.percentAssessmentPossible = 0
        } else {
          this.percentAssessmentNotenoughinfo = Math.round(newValue.assessmentCountNotEnoughInfo / newValue.assessmentCount * 100)
          this.percentAssessmentPossible = Math.round(newValue.assessmentCountPossible / newValue.assessmentCount * 100)
        }

        if (newValue.lsCount === 0) {
          this.percentLsNotEnoughInfo = 0
          this.percentLsVulnerable = 0
          this.percentLsHighlyVulnerable = 0
        } else {
          this.percentLsNotEnoughInfo = Math.round(newValue.lsCountNotEnoughInfo / newValue.lsCount * 100)
          this.percentLsVulnerable = Math.round(newValue.lsCountVulnerable / newValue.lsCount * 100)
          this.percentLsHighlyVulnerable = Math.round(newValue.lsCountHighlyVulnerable / newValue.lsCount * 100)
        }
      }
    },
    demographicField: function () {
      this.fetchPersonCountsByDemographic()
    },
    cseitDemographicField: function () {
      this.fetchCseitCountsByDemographic()
    },
    laborScreeningDemographicField: function () {
      this.fetchLaborScreeningCountsByDemographic()
    },
    demographicByTimeField: function () {
      this.fetchPersonDemographicsByTime()
    },
    demographicByTimeInterval: function () {
      this.fetchPersonDemographicsByTime()
    },
    assessmentDemographicField: function () {
      this.fetchAssessmentCountsByDemographic()
    },
    assessmentDemographicByTimeField: function () {
      this.fetchAssessmentDemographicsByTime()
    },
    assessmentDemographicByTimeInterval: function () {
      this.fetchAssessmentDemographicsByTime()
    },
    assessmentIndicatorOption: function (newValue) {
      const opts = this.getCommonStatsOpts()
      if (newValue !== 'All') {
        opts.dmst_conclusion = newValue
      }
      this.$store.dispatch('getReportAssessmentIndicators', opts)
    },
    cseitDemographicByTimeField: function () {
      this.fetchCseitDemographicsByTime()
    },
    laborScreeningDemographicByTimeField: function () {
      this.fetchLaborScreeningDemographicsByTime()
    },
    cseitDemographicByTimeInterval: function () {
      this.fetchCseitDemographicsByTime()
    },
    cseitIndicatorOption: function (newValue) {
      const opts = this.getCommonStatsOpts()
      if (newValue !== 'All') {
        opts.calc_cseitScore = newValue
      }
      this.$store.dispatch('getReportCseitIndicators', opts)
    },
    laborScreeningIndicatorOption: function (newValue) {
      const opts = this.getCommonStatsOpts()
      if (newValue !== 'All') {
        opts.conclusion = newValue
      }
      this.$store.dispatch('getReportLaborScreeningIndicators', opts)
    },
    usersTimeInterval: function () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getAllUsers', opts)
    }
  },
  data: function () {
    return {
      'someRandomSubsetOfStats': [],
      'assessmentsTimeInterval': 'All',
      'personsTimeInterval': 'All',
      'cseitTimeInterval': 'All',
      'demographicByTimeInterval': 'All',
      'demographicField': 'b_gender_identity',
      'cseitDemographicField': 'b_gender_identity',
      'assessmentDemographicField': 'b_gender_identity',
      'laborScreeningDemographicField': 'b_gender_identity',
      'laborScreeningDemographicByTimeField': 'b_gender_identity',
      'barDemographicField': 'b_gender_identity',
      'statisticsTimeInterval': 'All',
      'hideMonthGraphFilter': false,
      'hideDayGraphFilter': false,
      'demographicByTimeField': 'b_gender_identity',
      'cseitDemographicByTimeField': 'b_gender_identity',
      'assessmentDemographicByTimeField': 'b_gender_identity',
      'cseitDemographicByTimeInterval': 'All',
      'assessmentDemographicByTimeInterval': 'All',
      'assessmentIndicatorsFilter': 'All',
      'assessmentIndicatorOption': 'All',
      'cseitIndicatorOption': 'All',
      'laborScreeningIndicatorOption': 'All',
      'percentUnconfirmedPersons': 0,
      'percentConfirmedPersons': 0,
      'percentCseitNoconcern': 0,
      'percentCseitPossibleConcern': 0,
      'percentCseitClearConcern': 0,
      'percentLsNotEnoughInfo': 0,
      'percentLsVulnerable': 0,
      'percentLsHighlyVulnerable': 0,
      'percentAssessmentNotenoughinfo': 0,
      'percentAssessmentPossible': 0,
      'locationFilter': 'All',
      'customDateRange': {
        'startDate': moment(new Date()).format('ll'),
        'endDate': moment(new Date()).format('ll')
      },
      timezone: moment.tz.guess(),
      tabIndex: 0,
      hasVisitedTabMap: {
        [GLOBAL_REPORTS_TAB_INDEX.DEMOGRAPHICS]: false,
        [GLOBAL_REPORTS_TAB_INDEX.CSEIT]: false,
        [GLOBAL_REPORTS_TAB_INDEX.ASSESSMENT]: false,
        [GLOBAL_REPORTS_TAB_INDEX.LABOR_SCREENING]: false
      }
    }
  },
  methods: {
    handleSelect (customDateRange) {
      this.formatDateRange(customDateRange)
    },

    formatDateRange (customDateRange) {
      this.customDateRange.startDate = moment(customDateRange.startDate).format('ll')
      this.customDateRange.endDate = moment(customDateRange.endDate).format('ll')
    },

    saveCustomDateRange (clickApply) {
      clickApply()
      this.formatDateRange(this.customDateRange)
      if (this.statisticsTimeInterval !== 'Custom') {
        this.statisticsTimeInterval = 'Custom'
      } else {
        this.fetchStats()
      }
    },

    fetchStatsByTab (tabIndex) {
      switch (tabIndex) {
        case GLOBAL_REPORTS_TAB_INDEX.DEMOGRAPHICS:
          this.fetchDemographicsStats()
          break
        case GLOBAL_REPORTS_TAB_INDEX.CSEIT:
          this.fetchCseitStats()
          break
        case GLOBAL_REPORTS_TAB_INDEX.ASSESSMENT:
          this.fetchAssessmentStats()
          break
        case GLOBAL_REPORTS_TAB_INDEX.LABOR_SCREENING:
          this.fetchLaborScreeningStats()
          break
      }
    },

    fetchAssessmentDemographicsByTime () {
      const opts = this.getCommonStatsOpts()
      opts.demographic = this.assessmentDemographicByTimeField
      this.$store.dispatch('getReportAssessmentDemographicsByTime', opts)
      this.$store.dispatch('getReportAssessmentDemographicsByTimeNoInfoVictims', Object.assign(opts, {
        dmst_conclusion: 'No'
      }))
      this.$store.dispatch('getReportAssessmentDemographicsByTimePossibleVictims', Object.assign(opts, {
        dmst_conclusion: 'Yes'
      }))
    },

    fetchLaborScreeningDemographicsByTime () {
      const opts = this.getCommonStatsOpts()
      opts.demographic = this.laborScreeningDemographicByTimeField
      this.$store.dispatch('getReportLaborScreeningDemographicsByTime', opts)
    },

    fetchCseitDemographicsByTime () {
      const opts = this.getCommonStatsOpts()
      opts.demographic = this.cseitDemographicByTimeField
      this.$store.dispatch('getReportCseitDemographicsByTime', opts)
      this.$store.dispatch('getReportCseitDemographicsByTimeNoConcern', Object.assign(opts, {
        calc_cseitScore: 'No Concern'
      }))
      this.$store.dispatch('getReportCseitDemographicsByTimePossibleConcern', Object.assign(opts, {
        calc_cseitScore: 'Possible Concern'
      }))
      this.$store.dispatch('getReportCseitDemographicsByTimeClearConcern', Object.assign(opts, {
        calc_cseitScore: 'Clear Concern'
      }))
    },

    fetchPersonDemographicsByTime () {
      const opts = this.getCommonStatsOpts()
      opts.demographic = this.demographicByTimeField
      this.$store.dispatch('getReportPersonDemographicsOverTime', opts)
      this.$store.dispatch('getReportPersonDemographicsOverTimeUnconfirmed', Object.assign(opts, {
        b_confirmed: 'No'
      }))
      this.$store.dispatch('getReportPersonDemographicsOverTimeConfirmed', Object.assign(opts, {
        b_confirmed: 'Yes'
      }))
    },

    getCommonStatsOpts () {
      const startDate = new Date(this.customDateRange.startDate)
      const endDate = new Date(this.customDateRange.endDate)
      startDate.setHours(0, 0, 0, 0)
      endDate.setHours(23, 59, 59, 999)

      return {
        timeInterval: this.statisticsTimeInterval,
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        global: 'True',
        locationFilter: this.locationFilter,
        timezone: this.timezone
      }
    },

    fetchPersonCountsByDemographic () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getReportPersonCountsByDemographic', Object.assign(opts, {
        demographic: this.demographicField
      }))
    },

    fetchAssessmentCountsByDemographic () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getReportAssessmentCountsByDemographic', Object.assign(opts, {
        demographic: this.assessmentDemographicField
      }))
    },

    fetchCseitCountsByDemographic () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getReportCseitCountsByDemographic', Object.assign(opts, {
        demographic: this.cseitDemographicField
      }))
    },

    fetchLaborScreeningCountsByDemographic () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getReportLaborScreeningCountsByDemographic', Object.assign(opts, {
        demographic: this.laborScreeningDemographicField
      }))
    },

    fetchGeneralCounts () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getReportGeneralCounts', opts)
    },

    fetchDownloadData () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getAllUsers', opts)
      this.$store.dispatch('getAllOrgs', opts)
      this.$store.dispatch('getGroups', opts)
      this.$store.dispatch('getAllLogs', opts)
    },

    initHasVisitedTabMap () {
      // TODO
      Object.values(GLOBAL_REPORTS_TAB_INDEX).map((tabIndex) => {
        this.hasVisitedTabMap[tabIndex] = false
      })
    },

    fetchStats () {
      this.initHasVisitedTabMap()
      this.fetchGeneralCounts()
      this.fetchDownloadData()
      this.fetchStatsByTab(this.tabIndex)
    },

    fetchDemographicsStats () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getReportPersonCountsByTime', opts)
      this.fetchPersonCountsByDemographic()
      this.fetchPersonDemographicsByTime()
    },

    fetchCseitStats () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getReportCseitCountsByTime', opts)
      this.$store.dispatch('getReportCseitIndicators', opts)
      this.$store.dispatch('getScreeningsByOrg', opts)
      this.fetchCseitCountsByDemographic()
      this.fetchCseitDemographicsByTime()
    },

    fetchAssessmentStats () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getReportAssessmentCountsByTime', opts)
      this.$store.dispatch('getReportAssessmentIndicators', opts)
      this.fetchAssessmentCountsByDemographic()
      this.fetchAssessmentDemographicsByTime()
    },

    fetchLaborScreeningStats () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getReportLaborScreeningCountsByTime', opts)
      this.$store.dispatch('getReportLaborScreeningIndicators', opts)
      this.$store.dispatch('getLaborScreeningsByOrg', opts)
      this.fetchLaborScreeningCountsByDemographic()
      this.fetchLaborScreeningDemographicsByTime()
    },

    goToConfirmed () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'b_confirmed': 'Yes'
        }
      })
    },

    goToBlankConfirmed () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'b_confirmed': 'No'
        }
      })
    },

    goToNotEnoughInfo () {
      // Not Used Lighthouse Indicators or latest assessment result removed from dashboard.
      this.$router.push({
        path: '/dashboard',
        query: {
          'dmst_conclusion': '0'
        }
      })
    },

    goToPossible () {
      // Not Used Lighthouse Indicators or latest assessment result removed from dashboard.
      this.$router.push({
        path: '/dashboard',
        query: {
          'dmst_conclusion': 'Yes'
        }
      })
    },

    goToNoConcern () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'cseit_conclusion': 'No Concern'
        }
      })
    },

    goToPossibleConcern () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'cseit_conclusion': 'Possible Concern'
        }
      })
    },

    goToClearConcern () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'cseit_conclusion': 'Clear Concern'
        }
      })
    },

    goToLSNotEnoughInfo () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'ls_conclusion': LABOR_SCREENING_CONCLUSION.NOT_ENOUGH_INFO
        }
      })
    },

    goToLSVulnerable () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'ls_conclusion': LABOR_SCREENING_CONCLUSION.LEVEL1
        }
      })
    },

    goToLSHighlyVulnerable () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'ls_conclusion': LABOR_SCREENING_CONCLUSION.LEVEL2
        }
      })
    },

    _getLaborScreeningQuestionBasedOnPrefix (key) {
      if (key.endsWith('otherText')) {
        switch (key) {
          case 'e_fl_otherText':
            return 'Forced Labor - Other'
          case 'e_db_otherText':
            return 'Debt Bondage - Other'
          case 'm_c_otherText':
            return 'Coercion - Other'
          case 'm_fr_otherText':
            return 'Fraud - Other'
          case 'm_fo_otherText':
            return 'Force - Other'
          case 'p_otherText':
            return 'Process - Other'
        }
      }

      switch (true) {
        case key.startsWith('e_fl_'):
          return this.laborScreeningFields.ENDS.FORCED_LABOR[key].label
        case key.startsWith('e_db_'):
          return this.laborScreeningFields.ENDS.DEBT_BONDAGE[key].label
        case key.startsWith('m_c_'):
          return this.laborScreeningFields.MEANS.COERCION[key].label
        case key.startsWith('m_fr_'):
          return this.laborScreeningFields.MEANS.FRAUD[key].label
        case key.startsWith('m_fo_'):
          return this.laborScreeningFields.MEANS.FORCE[key].label
        case key.startsWith('p_'):
          return this.laborScreeningFields.PROCESS[key].label
      }
    },
    transformLaborScreeningIndicatorKey (key) {
      return this._getLaborScreeningQuestionBasedOnPrefix(key)
    }
  },

  mounted () {
    this.fetchStats()
    this.hasVisitedTabMap[GLOBAL_REPORTS_TAB_INDEX.DEMOGRAPHICS] = true
  }
}
</script>
<style>
  #global-statistics-tabs {
    margin-bottom: 50px;
  }
  .clickable-card{
    cursor: pointer;
  }
  .col-sm-6 .text-center {
    width: 400px;
    margin: auto;
  }
  .column-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  @media screen and (max-width: 548px) {
    .location-filter-select {
      margin: 10px 0;
    }
  }
  .reportrange-text.form-control {
    padding: 0 !important;
    border: none !important;
    overflow: auto !important;
    height: auto !important;
  }

  .date-range-picker__footer {
    display: flex;
    justify-content: flex-end;
    padding: 10px;
    box-sizing: border-box;
  }

  .calendars {
    justify-content: center;
  }

  .date-range-picker__header {
    display: flex;
    padding: 0 5px 10px;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #f2f2f2;
    gap: 5px;
  }

  .date-range-picker__header label {
    margin-bottom: 0;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/views/t1/GlobalReport.vue